/* eslint-disable max-len */

export const helpStepPersonalData = [
    {
        title: "Persona Expuesta Políticamente (PEP)",
        description:
            "Las PEP son individuos que cumplen o a quienes se les han confiado funciones públicas prominentes en su país, en otro país o por una organización internacional como por ejemplo los Jefes de Estado o de Gobierno, políticos de alto nivel, funcionarios gubernamentales o judiciales de alto nivel o militares de alto rango, ejecutivos de alto nivel de corporaciones estatales, funcionarios de partidos políticos importantes”.",
    },
    {
        title: "Residente fiscal en el exterior",
        description:
            "La residencia fiscal es un concepto que permite saber en qué país tributa un contribuyente, coincidiendo usualmente con la ubicación física de la persona. Es decir, la residencia fiscal es el lugar donde el individuo tiene obligaciones fiscales, debiendo declarar sus rentas y pagar impuestos.",
    },
    {
        title: "FATCA",
        description:
            "La Ley sobre el Cumplimiento Fiscal relativa a Cuentas en el Extranjero (FATCA, por sus siglas en inglés) se refiere a aquellas cuentas que pertenecen a contribuyentes estadounidenses pero se mantienen fuera de los EE.UU.",
    },
    {
        title: "CRS",
        description:
            "La Normativa CRS (Estándar Común de Reporte o Common Reporting Standard), es un sistema de intercambio automático de información tributaria entre los países adheridos. Esto permitirá a las Administraciones tributarias disponer de forma periódica de información fiscal de todas las inversiones que sus contribuyentes mantienen en otras entidades del extranjero.",
    },
    {
        title: "OCDE",
        description:
            "La Organización para la Cooperación y el Desarrollo Económicos es un organismo de cooperación internacional compuesto por 38 estados, cuyo objetivo es coordinar sus políticas económicaOCDEs y sociales.",
    },
];

export default helpStepPersonalData;
